import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Draggable from 'react-draggable';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PartService from "../../Controller/PartController";
import PartBatchService from "../../Controller/PartBatchController";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
function CreateCustomerSite({ BatchID, onClose }) {

    const { t } = useTranslation();

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [isMinimized, setIsMinimized] = useState(false);
    const [batchRecord, setBatchRecord] = useState([]);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const activeDateFormat = useDateFormat();
    const fetchBatchStatus = async (BatchID) => {
        try {
            const batchStatus = await PartBatchService.GetBatchStatuses(BatchID);
            setBatchRecord(batchStatus);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };


    useEffect(() => {
        fetchBatchStatus(BatchID);
    }, [BatchID]);

    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        <div>

            <div className="modal fade stockBatchModal show d-block" id="stockBatchModal" tabIndex="-1" aria-labelledby="stockBatchModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">

                        <div className="modal-content" style={{ height: '100%', width: '100%' }}>
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Batch Record</h5>


                                <span>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                        <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                    </button>

                                </span>


                            </div>
                            {!isMinimized && (
                                <div className="modal-body">

                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <table className="table m-0 table-hover table-bordered table-striped" style={{ "width": "100%" }}>
                                            <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                                <tr>
                                                    <th className="no-wrap">In Stock</th>
                                                    <th className="no-wrap">Allocated</th>
                                                    <th className="no-wrap">Invoiced</th>
                                                    <th className="no-wrap">Sale Order</th>
                                                    <th className="no-wrap">Action By</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {batchRecord.map((stock, index) => {

                                                    const date = new Date(stock.dt_Added);
                                                    const formattedTime = date.toLocaleTimeString('en-US', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: false, // Use 24-hour format
                                                    });
                                                    return (
                                                        <tr >
                                                            <td className="no-wrap">{stock.Available}</td>
                                                            <td className="no-wrap">{stock.Allocated}</td>
                                                            <td className="no-wrap">{stock.Invoiced}</td>
                                                            <td className="no-wrap">{stock.bnt_OrderNumber}</td>
                                                            <td className="no-wrap">{stock.DisplayName}</td>

                                                        </tr>
                                                    );
                                                })}
                                            </tbody>



                                        </table>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
                                    </div>

                                </div>
                            )}
                        </div>

                    </Draggable>
                </div>
            </div>


        </div>
    );
}

export default CreateCustomerSite;
